<template>
  <div class="image-up-wrapper choose-button">
    <span class="iconfont icon-paizhao"></span>
    <input ref="file" name="file" type="file" accept="image/*" @change="onImageChange">
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    imageChange: {
      type: Function
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    onImageChange (e) {
      if (!e.target || e.target.files.length === 0) return
      const filename = e.target.files[0].name.split('.')[1]
      const file = e.target.files[0]
      this.imageChange && this.imageChange(filename, file)
      this.$refs.file.value = null
    }
  },
  created () {},
  mounted () {}
}
</script>
<style lang="stylus" scoped>
.image-up-wrapper.choose-button {
    border 1PX dashed #ebebeb
    position relative
    overflow hidden
    height 100%
    box-sizing: border-box;
    .icon-paizhao {
      display block
      color white
      font-size 50px
      height 50px
      width 50px
      line-height 50px
      text-align center
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%)
    }
    input{
      position absolute
      left 0
      top 0
      right 0
      bottom 0
      width 100%
      height 100%
      background-color yellow
      opacity 0
    }
  }
</style>
